<template lang="pug">
el-form(ref='titles', :inline='true', :model='application.titles', label-width='160px', size='small')
  el-form-item(label='Τύπος Φοίτησης')
    | {{distant}}
  el-form-item(label='Μερική', v-show="distant === 'Συμβατικός'")
    | {{application.titles.partTime ? 'Ναι' : 'Όχι'}}
  div(v-show="distant === 'Εξ αποστάσεως'")
    el-form-item(label=' ')
      el-checkbox(label='Μέρος έγινε στην Ελλάδα', name='application.titles.partOfStudiesGr',
      v-model='application.titles.partOfStudiesGr', :disabled='true')
    el-form-item(label='Πόλη', v-show='application.titles.partOfStudiesGr')
      | {{application.titles.cityOfStudiesGr}}
    el-form-item(label='Ίδρυμα', v-show='application.titles.partOfStudiesGr')
      | {{application.titles.institutionOfStudiesGr}}
  div(v-show="application.degreeType !== 'bachelor'")
    el-form-item(label='Βασικό Πτυχίο σε')
      el-switch(v-model="application.titles.greekBachelor", active-text="Ελληνικό Πανεπιστήμιο",
        inactive-text="Πανεπιστήμιο του εξωτερικού", :disabled='true')
    el-form-item(label='Τμήμα Πανεπιστημίου', v-show='application.titles.greekBachelor')
      | {{application.titles.greekBachelorInserted}}
    el-form-item(label='Πράξη αναγνώρισης', v-show='!application.titles.greekBachelor')
      | {{application.titles.greekBachelorInserted}}
    el-form-item(label='Με Βαθμολογική Αντιστοίχιση' v-show='application.degreeType === "master"')
      | {{ scoreMatchString }}
  hr
  el-form-item(label='Χώρα Σπουδών' v-if='application.titles.country.name !== null && application.titles.country.name !== "other"')
    | {{application.titles.country.name}}
  el-form-item(label='Χώρα Σπουδών' v-if='application.titles.country.name === "other"')
    | {{application.titles.country.countryInserted}}
    div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝH Χώρα
  div
    el-form-item(label='Πανεπιστήμιο' v-if='application.titles.university.name !== null && application.titles.university.name !== "other"')
      | {{application.titles.university.name}}
      el-alert(:closable='false' v-if="omotages && omotages.university && omotages.university[0].accredited === 'yes'" title='Το ίδρυμα είναι ομοταγές' type='success' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.university && omotages.university[0].accredited === 'no'" title='Το ίδρυμα δεν είναι ομοταγές' type='error' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.university && omotages.university[0].accredited === 'under investigation'" title='Μη κριθέν ίδρυμα' type='warning' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.university && omotages.university[0].accredited === 'No data found for University.'" title='Δε βρέθηκαν στοιχεία για το συγκεκριμένο ίδρυμα' type='warning' show-icon='')
    el-form-item(label='Πανεπιστήμιο' v-if='application.titles.university.name === "other"')
      | {{application.titles.university.universityInserted}}
      div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Πανεπιστήμιο
  div
    el-form-item(label='Κολλέγιο', v-if='application.titles.college.name !== null && application.titles.college.name !== "other"')
      | {{application.titles.college.name}}
      el-alert(:closable='false' v-if="omotages && omotages.college && omotages.college[0] && omotages.college[0].accredited === 'yes'" title='Το κολέγιο είναι αναγνωρισμένο' type='success' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.college && omotages.college[0] && omotages.college[0].accredited === 'no'" title='Το κολέγιο δεν είναι αναγνωρισμένο' type='error' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.college && omotages.college[0] && omotages.college[0].accredited === 'under investigation'" title='Μη κριθέν κολέγιο' type='warning' show-icon='')
    el-form-item(label='Κολλέγιο', v-if='application.titles.college.name === "other"')
      | {{application.titles.college.collegeInserted}}
      div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Κολλέγιο
  div
    el-form-item(label='Σχολή' v-if='application.titles.faculty.name !== null && application.titles.faculty.name !== "other"')
      | {{application.titles.faculty.name}}
      el-alert(:closable='false' v-if="omotages && omotages.faculty && omotages.faculty[0] && omotages.faculty[0].accredited === 'yes'" title='Η σχολή είναι αναγνωρισμένη' type='success' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.faculty && omotages.faculty[0] && omotages.faculty[0].accredited === 'no'" title='Η σχολή δεν είναι αναγνωρισμένη' type='error' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.faculty && omotages.faculty[0] && omotages.faculty[0].accredited === 'under investigation'" title='Μη κριθείσα σχολή' type='warning' show-icon='')
    el-form-item(label='Σχολή', v-if='application.titles.faculty.name === "other"')
      | {{application.titles.faculty.facultyInserted}}
      div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΗ ΣΧΟΛΗ
  div
    el-form-item(label='Τμήμα' v-if='application.titles.department.name !== null && application.titles.department.name !== "other"')
      | {{application.titles.department.name}}
      el-alert(:closable='false' v-if="omotages && omotages.department && omotages.department[0] && omotages.department[0].accredited === 'yes'" title='Το τμήμα είναι αναγνωρισμένο' type='success' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.department && omotages.department[0] && omotages.department[0].accredited === 'no' " title='Το τμήμα δεν είναι αναγνωρισμένο' type='error' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.department && omotages.department[0] && omotages.department[0].accredited === 'under investigation'" title='Μη κριθέν τμήμα' type='warning' show-icon='')
    el-form-item(label='Τμήμα', v-if='application.titles.department.name === "other"')
      | {{application.titles.department.departmentInserted}}
      div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Τμήμα
  hr
  el-form-item.compact-form-item(label='Τίτλος Σπουδών (όπως υποβλήθηκε)')
    | {{application.titles.certificationTitle}}
  div
    el-form-item(label='Πιστωτικές Μονάδες')
      | {{application.titles.credits}}
    el-form-item(label='Διάρκεια Σπουδών')
      | {{application.titles.durationOfStudies}}
    el-form-item(label='Συνυποβολή Τίτλου', v-show="application.degreeType === 'bachelor'")
      el-checkbox(label='Επιθυμώ', name='synektimisi', v-model='application.consideration', disabled)
  div
    el-form-item(label='Ημέρ. Εγγραφής')
      | {{application.titles.dateOfRegistration}}
    el-form-item(label='Ημερ. Αποφοίτησης')
      | {{application.titles.dateOfGraduation}}
  div
    el-form-item(label='Βαθμός πτυχίου')
      | {{application.grade}}
    el-form-item(label='Χαρακτηρισμός')
      | {{application.grade_description}}
  div
    el-form-item(label='Τίτλος Σπουδών')
      | {{ application.certificationTitleByInternal || application.titles.certificationTitle }}
  hr
  el-form-item(label='Οι σπουδές έγιναν')
    el-switch(v-model="application.titles.studiesInMoreUniversities", :disabled='true', active-text="σε περισσότερα Πανεπιστήμια",
      inactive-text="σε ένα Πανεπιστήμιο")
  div(v-show='application.titles.studiesInMoreUniversities')
    div(v-for="(additionalUni, index) in application.titles.additionalUniversities")
      el-form-item(label='Πανεπιστήμιο' v-show="additionalUni.university != null")
        | {{additionalUni.university}}
      el-form-item(label='Μονάδες'  v-show="additionalUni.credits != null")
        | {{additionalUni.credits}}
  div(v-if="application.degreeType === 'bachelor'")
    hr
    el-alert(:closable='false' v-if="application.correspondence==false" title='Eπιλογή ΜΟΝΟ Ισοτιμίας' type='warning' show-icon)
    br
    el-form-item(label='Αναγνώριση τίτλου με')
      | {{isConsideration}}
    div(v-if="application.correspondence")
      el-form-item(label=' ',
      v-if="application.recognitionWith === 'aei' || application.recognitionWith === 'aeiAndTei'")
        | {{application.titlesCorrespondence.universityDepartment.name}}
      //- el-form-item(label='Τμήμα ΤΕΙ',
      //- v-if="application.recognitionWith === 'tei' || application.recognitionWith === 'aeiAndTei'")
      //-   | {{application.titlesCorrespondence.TEIDepartment.name}}
  el-button(type='primary' icon='el-icon-search' size='small' @click='listAllDepartments()' v-if='this.activeRole === "PreChecker"') Λίστα Ελλ. Ιδρυμάτων
  el-dialog(title='Λίστα Ελληνικών Ιδρυμάτων προς Αντιστοίχιση', :visible.sync='showUniList', width='60%')
    el-table(:data='allDepartments' style='width: 100%' stripe border highlight-current-row v-loading='loadingDepts' height='350')
      el-table-column(label='Ίδρυμα' width='300')
        template(slot-scope='scope')
          i.el-icon-news
          span(style='margin-left: 10px') {{ scope.row.institution_name }}
      el-table-column(label='Τμήμα' width='350')
        template(slot-scope='scope')
          i.el-icon-management
          span(style='margin-left: 10px') {{ scope.row.department_name }}
</template>

<script>

import config from '../../config.js'
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  props: ['application', 'omotages'],
  data () {
    return {
      showUniList: false,
      allDepartments: [],
      loadingDepts: false
    }
  },
  computed: {
    scoreMatchString () {
      return this.application.scoreMatch ? 'NAI' : 'OXI'
    },
    distant () {
      return this.application.titles.distant ? 'Εξ αποστάσεως' : 'Συμβατικός'
    },
    isCorrespondence () {
      if (this.application.recognitionWith === 'aeiAndTei') {
        return 'με Πανεπιστήμιο ή με ΤΕΙ'
      } else if (this.application.recognitionWith === 'aei') {
        return ' μόνο με Πανεπιστήμιο'
      } else if (this.application.recognitionWith === 'tei') {
        return ' μόνο με ΤΕΙ'
      } else {
        return ' χωρίς'
      }
    },
    isConsideration () {
      // return this.application.correspondence ? 'Αντιστοιχία και Ισοτιμία' : 'Ισοτιμία'
      return this.application.consideration ? 'Ακαδημαϊκή ισοδυναμία με συνυποβολή τίτλου 2ου κύκλου σπουδών' : 'Ακαδημαϊκή ισοδυναμία'
    },
    ...mapGetters({ activeRole: 'activeRole' })
  },
  methods: {
    listAllDepartments () {
      this.loadingDepts = true
      this.showUniList = true
      axios.get(
        `${config.BASE_URL}/greekInstitutions`
      )
        .then(response => {
          this.loadingDepts = false
          this.allDepartments = response.data.data
        })
    }
  }
}
</script>

<style scoped lang="scss">
.el-form-item {
  color: rgb(30, 0, 128);
  font-weight: bold;
  // border-radius: 10px;
  // border-style: solid;
  // border-color: #7fa3bb green #86b8da yellow;
  // border-width: 0px 0px 2px 0px;
  // border: 2px 0px 0px 0px solid #7fa3bb;
  padding-right: 20px;
  padding-left: 10px;
}
// .el-input.is-disabled .el-input__inner {
//   background-color: #f5f7fa;
//   border-color: #e4e7ed;
//   color: #1b5cde;
//   cursor: not-allowed;
// }
// .el-checkbox__input.is-disabled+span.el-checkbox__label {
//   color: #1b91de;
// }
// input.el-input__inner {
//   color: #3e67b9;
// }
.el-input {
  &.bigger {
    width: 530px;
  }
}
.el-input {
  &.biggest {
    width: 1040px;
  }
}
.el-input {
  &.big {
    width: 450px;
    color: #3e67b9;
  }
}
.el-input--small .el-input__inner {
  width: 300px
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 190px;
}
.el-checkbox__input.is-disabled+span.el-checkbox__label {
  color: #1b91de;
}
.el-alert {
  background-color: unset;
  font-style: normal;
  text-align:left;
  display: inline;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Titles.vue